import { ReactComponent as TestIcon } from '@elementary/common-ui/assets/test.svg';
import { WidgetButton } from '@elementary/common-ui/components';
import useNavigateWithEnvParam from '@elementary/common-ui/hooks/useNavigateWithEnvParam';

type Props = {
  urlParam: string;
};

const OpenTestRunsButton = ({ urlParam }: Props) => {
  const navigate = useNavigateWithEnvParam();

  return (
    <WidgetButton
      onClick={() => navigate(`/report/test-runs/${urlParam}/`)}
      startIcon={<TestIcon width={12} />}
    >
      Test runs
    </WidgetButton>
  );
};

export default OpenTestRunsButton;
